var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.marker.order)?_c('OrderInfoBox',{attrs:{"order":_vm.marker.order,"show":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }